export default "__VITE_ASSET__653a05ae__"